/* wbpk-const export */ const CSRF_TOKEN_HEADER_NAME = 'X-Csrf-Token';

let csrfToken = '';

/* wbpk-export-def-class export default  */ class CsrfHelper {

    /**
     * Set new CSRF token value.
     * @param  {string} value CSRF token.
     * @return {undefined}
     */
    static set(value) {
        csrfToken = value;
    }

    /**
     * Get CSRF token vlaue.
     * @return {string} CSRF token.
     */
    static get() {
        return csrfToken;
    }

    /**
     * Is CSRF token exists
     * @return {boolean}
     */
    static isset() {
        return !!csrfToken;
    }

    /**
     * Deletes old CSRF token
     */
    static delete() {
        csrfToken = '';
    }
}
